import Vue from 'vue';
import Router from 'vue-router';
import Demo from '@/pages/Demo';
import Info from '@/pages/Info';
import SubMenu from '@/pages/SubMenu';
import SubVodMenu from '@/pages/SubVodMenu';
// import Image from '@/components/ViewerImage';
// import Video from '@/components/VideoPlayer';
// import Website from '@/components/WebViewer';
import TVPlayer from '@/pages/TVPlayer';
import RadioPlayer from '@/pages/RadioPlayer';
import KeyHandling from '@/components/InfoKeyHandling';
import InfoDashboard from '@/components/InfoDashboard';

import PageRegistration from '@/pages/Registration';
import Home from '@/pages/Home';
import MediaPlayer from '@/pages/MediaPlayer';
import InputSource from '@/pages/InputSource';
import SourceSelect from '@/pages/SourceSelect';
import WelcomePage from '@/pages/Welcome';
import Vod from '@/pages/Vod';
import EPGGuide from '@/pages/EPGGuide';
import EPGGuide2 from '@/pages/EPGGuide2';
import Cast from '@/pages/Cast';
import AppInstall from '@/pages/AppInstall';

import Requests from '@/helpers/Request';
import Registration from '@/helpers/Registration';
import TV from '@/helpers/TV';
import store from '@/store';
import device from '@/store/modules/device';

Vue.use(Router);

// Auf diesen Seiten werden die Jetzt-/Danach-Daten (epgNow) vorgewaermt.
//
// Verbraucher ist einzig der TVPlayer - sein OSD liest getNowNext fuer den
// fokussierten Sender. Home steht dabei, weil von dort in den TVPlayer
// gesprungen wird und das Vorwaermen VOR dem Oeffnen fertig sein soll; im
// TVPlayer selbst deckt es Rueckkehr und Blaettern ab.
//
// Die beiden TV-Guides gehoeren NICHT dazu: sie lesen epgNow nicht, und der
// Sprung von dort geht auf genau einen Sender, der nicht unter den ersten
// PREWARM_CHANNELS liegen muss. Beim Guide v2 findet epgNow/ensureChannel
// diesen Sender ohnehin gratis in epgGuide2.programsByChannel.
const EPG_PREWARM_ROUTES = ['Home', 'TVPlayer'];

// Seiten, auf denen ein Live-Bild des GERAETS laufen darf. Ueberall sonst wird
// der Tuner beim Betreten gestoppt (siehe router.afterEach unten).
//
// TVPlayer/RadioPlayer tunen selbst, die beiden TV-Guides zeigen eine
// Live-Vorschau (TV.startPreview), und InputSource/SourceSelect zeigen eine
// externe Quelle - dort waere ein Stopp genau das Falsche.
const LIVE_VIDEO_ROUTES = [
  'TVPlayer',
  'RadioPlayer',
  'EPGGuide',
  'EPGGuide2',
  'InputSource',
  'SourceSelect',
];

// Laeuft moeglicherweise ein Bild/Ton des Geraets, den wir nicht wollen?
//
// Der Merker spart Aufrufe: ohne ihn schickt jeder Menueklick zwei
// hcap-Kommandos an den TV, und hcap.js schreibt zu jedem drei console-Zeilen,
// die der Live-Log im Admin spiegelt. Gestoppt wird deshalb einmal - bis
// wieder etwas laufen KANN: nach einer Live-Seite oder nach der Rueckkehr aus
// dem Standby (siehe noteTunerMayPlay, gerufen aus main.js).
let tunerSilenced = false;

// Ruhezeit nach einem eigenen Stopp - siehe den channel_status_changed-Listener
// unten: unser stop_current_channel loest dasselbe Ereignis aus, auf das wir
// hoeren. Ohne diese Sperre antwortete die App auf ihren eigenen Stopp mit dem
// naechsten Stopp.
const TUNER_EVENT_QUIET_MS = 5000;
let lastTunerStop = 0;

// Stoppt, wenn die uebergebene Seite kein Live-Bild zeigt. Gemeinsame Mitte von
// afterEach, noteTunerMayPlay und dem Tuner-Ereignis, damit alle drei dieselbe
// Liste benutzen.
function silenceTunerFor(routeName) {
  if (LIVE_VIDEO_ROUTES.indexOf(routeName) !== -1) {
    // Hier laeuft gleich wieder etwas - der naechste Wechsel muss neu stoppen.
    tunerSilenced = false;
    return;
  }
  if (tunerSilenced) return;
  tunerSilenced = true;
  lastTunerStop = Date.now();
  TV.stopPlayback('Seite ohne Live-Bild: ' + (routeName || '?'));
}

/**
 * Ab jetzt kann wieder Geraete-Ton laufen - also gleich nachsehen.
 *
 * Nicht nur den Merker zuruecknehmen: beim Aufwachen aus dem Standby steht die
 * App oft schon auf Home, dann gibt es gar keinen Seitenwechsel mehr, den
 * afterEach abfangen koennte - und der Ton bliebe.
 */
export function noteTunerMayPlay() {
  tunerSilenced = false;
  silenceTunerFor(router.currentRoute && router.currentRoute.name);
}

const parseQueryString = (value) => {
  if (!value) return;
  const decoded = decodeURI(value);
  if (decoded[0] === '"') {
    return decoded.substring(1, decoded.length - 1);
  }
  return decoded;
};

const router = new Router({
  routes: [
    {
      path: '/demo',
      name: 'Demo',
      component: Demo,
    },
    {
      path: '/info',
      component: Info,
      children: [
        {
          path: 'keyhandling',
          component: KeyHandling,
        },
        {
          path: '',
          name: 'Info',
          component: InfoDashboard,
        },
      ],
    },
    // {
    //   path: '/image/:src/:alt',
    //   name: 'Image',
    //   component: Image,
    //   props: true,
    // },
    // {
    //   path: '/video/:src',
    //   name: 'Video',
    //   component: Video,
    //   props: true,
    // },
    // {
    //   path: '/website/:url',
    //   name: 'Website',
    //   component: Website,
    //   props: true,
    // },
    //TODO: SubVodMenu -> SubMenu
    {
      path: '/sub-menu/VodList',
      component: SubVodMenu,
      name: 'SubVodMenu',
      props: true,
      beforeEnter: async (to, from, next) => {
        /*if (!to.params.id) {
          next({ name: 'Home' });
        }*/
        await store.dispatch('vod/fetchVodSubMenu', to.params);
        next();
      },
    },
    /*
    {
      path: '/sub-menu/language',
      component: SubMenu,
      name: 'SubMenu',
      props: true,
      beforeEnter: async (to, from, next) => {
        if (!to.params.id) {
          next({ name: 'Home' });
        }
        //if(to.params.id == 'VodList') {
        //  await store.dispatch('vod/fetchVodSubMenu', to.params);
        //} else {
          await store.dispatch('navigation/fetchSubMenu', to.params);
        //}
        next();
      },
    },
    */
    {
      path: '/sub-menu/:id?',
      component: SubMenu,
      name: 'SubMenu',
      props: true,
      beforeEnter: async (to, from, next) => {
        if (!to.params.id) {
          next({ name: 'Home' });
        }
        //if(to.params.id == 'VodList') {
        //  await store.dispatch('vod/fetchVodSubMenu', to.params);
        //} else {
          await store.dispatch('navigation/fetchSubMenu', to.params);
        //}
        next();
      },
    },
    // {
    //   path: '/sub-menu',
    //   redirect: { name: 'Home' },
    // },
    {
      path: '/sub-vodmenu/:id?',
      component: SubVodMenu,
      name: 'VodSubMenu',
      props: true,
      beforeEnter: async (to, from, next) => {
        console.log("---------------------------------------TO_vod", to);
        if (!to.params.id) {
          next({ name: 'Vod' });
        }
        await store.dispatch('vod/fetchVodSubMenu', to.params);
        next();
      },
    },
    {
      path: '/registration',
      name: 'Registration',
      component: PageRegistration,
    },
    {
      path: '/media-player/:id?',
      component: MediaPlayer,
      name: 'MediaPlayer',
      props: (route) => {
        return {
          src: parseQueryString(route.query.src),
          type: parseQueryString(route.query.type),
          seekTo: parseQueryString(route.query.seekTo),
          title: parseQueryString(route.query.title),
          description: parseQueryString(route.query.description),
          loop: parseQueryString(route.query.loop) === '1',
          controls: parseQueryString(route.query.controls) !== 'false',
        };
      },
    },
    {
      path: '/tv-player',
      component: TVPlayer,
      name: 'TVPlayer',
      props: (route) => ({ origin: route.query.origin || 'home' }),
    },
    {
      path: '/radio-player',
      component: RadioPlayer,
      name: 'RadioPlayer',
    },
    {
      path: '/welcome',
      component: WelcomePage,
      name: 'WelcomePage',
    },
    {
      path: '/vod',
      component: Vod,
      name: 'Vod',
      props: true,
      /*
      beforeEnter: async (to, from, next) => {
        console.log('TO: ', to);
        //if(!to.params.id) {
        //  next({ name: 'Home' });
        //}
        await store.dispatch('vod/fetchVodMenu', to.params);
        next();
      },
      */
    },
    {
      path: '/epg-guide',
      component: EPGGuide,
      name: 'EPGGuide',
    },
    {
      // TV-Guide v2 - eigene Route, damit die alte Version unveraendert
      // erreichbar bleibt und beide parallel getestet werden koennen.
      path: '/epg-guide-2',
      component: EPGGuide2,
      name: 'EPGGuide2',
    },
    {
      path: '/cast',
      component: Cast,
      name: 'Cast',
    },
    {
      // Service-Seite fuer die App-Installation. Der Pfad beginnt absichtlich
      // mit "/info", damit sie unter die Ausnahme in router.beforeEach faellt
      // und ohne Registrierung/device-init erreichbar ist - wie die Info-Seite.
      path: '/info-apps',
      component: AppInstall,
      name: 'AppInstall',
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter(to, from, next) {
        store.dispatch('navigation/callNextActionCallback');
        next();
      },
    },
    {
      path: '/init-device/:bid/:deviceId/:room',
      name: 'InitDevice',
      beforeEnter(to, from, next) {
        console.log(to), Registration.saveData(to.params);
        next({ name: 'Home' });
      },
    },
    {
      path: '/input-source',
      component: InputSource,
      props: true,
      name: 'InputSource',
    },
    {
      path: '/sourceselect',
      component: SourceSelect,
      props: true,
      name: 'SourceSelect',
    },
  ],
});//.catch(() => {});

router.beforeEach(async (to, from, next) => {
  store.commit('setIsLoadedState', false);
  // store.dispatch('notification/new', {
  //   title: 'To ' + to.name,
  //   message: 'Path: ' + to.path,
  // });
  //console.log('TO', to);
  try {
    store.dispatch('lang/init');
  } catch (err) {
    return location.reload(true);
  }
  if (
    to.name === 'Registration' ||
    to.name === 'Demo' ||
    to.name === 'SubMenu' ||
    to.name === 'Website' ||
    to.name === 'Video' ||
    to.name === 'Image' ||
    to.name === 'Vod' ||
    to.name === 'SubVodMenu' ||
    to.name === 'InitDevice' ||
    to.path.includes('/info') ||
    to.path.includes('/init-device')
  ) {
    store.commit('setIsLoadedState', true);
    return next();
  }

  const { bid, deviceId, room } = Registration.getData;
  // store.dispatch('notification/new', {
  //   title: 'Registrated data',
  //   message: `Bid: ${bid}, DeviceId: ${deviceId}, Room: ${room}`,
  // });
  if (!bid || !deviceId || !room) {
    // store.dispatch('notification/new', {
    //   title: 'No Params',
    // });
    store.commit('setIsLoadedState', true);
    return next({ name: 'Registration' });
  }

  try {
    await store.dispatch('device/init');
  } catch (err) {
    // store.dispatch('notification/new', {
    //   title: 'Device/init failed',
    // });
    console.log('Error: router:device/init - ', err);
    store.commit('setIsLoadedState');
    // ! NO DEVICE RESET POSSIBLE => SOCKET CALL NEEDED
    //return next({ name: 'Registration' });

    return location.reload(true);
  }

  // HAVE TO HANDLE REQUEST

  store.dispatch('customizer/fetchCustomizerSettings').catch((err) => {
    console.log('Error: router:customizer/fetchCustomizerSettings - ', err);
  });
  store.dispatch('socket/init').catch((err) => {
    console.log('Error: router:socket/init – ', err);
  });
  /*store.dispatch('logger/init').catch((err) => {
    console.log('Error: router:logger/init – ', err);
  });*/
  // Die Cast-Seite zeigt weder Kanalliste noch EPG - dort das Vorwaermen der
  // TV-Daten auslassen. tv/prepare holt die Kanalliste sonst bei jedem Aufruf
  // neu ueber das Netz, ohne dass sie auf der Seite gebraucht wird.
  store.dispatch('navigation/init', {
    warmTv: to.name !== 'Cast',
    prewarmEpg: EPG_PREWARM_ROUTES.indexOf(to.name) !== -1,
  }).catch((err) => {
    console.log('Error: router:navigation/init - ', err);
  });
  /*store.dispatch('vod/init').catch((err) => {
    console.log('Error: router:vod/init - ', err);
  });*/

  store.commit('setIsLoadedState');
  // END
  return next();
});

// Kein Bild auf der Seite, also auch kein Ton aus dem Geraet.
//
// DER ANLASS: hat jemand am TV selbst einen Sendersuchlauf gemacht (DVB oder
// die geraeteeigenen Internet-Kanaele), spielt der Tuner weiter, waehrend unsere
// App darueber liegt - der Gast hoert auf einer Info- oder Menueseite den Ton
// eines fremden Senders. Aufgefallen auf einem LG (webOS 25) beim Oeffnen eines
// Menuepunkts; auf Samsung ist die Lage dieselbe. Nach einer sauberen
// Installation gibt es diese Sender nicht - im Feld aber eben doch.
//
// Bisher stoppte das NUR die Cast-Seite (helpers/Cast ist dort nicht das
// Thema, siehe Cast.vue silenceTuner). Jede andere Seite liess den Ton laufen.
// Deshalb steht es hier zentral, statt in jeder Seite einzeln - der naechste
// neue Menuepunkt ist sonst wieder betroffen.
//
// WARUM afterEach und nicht beforeEach: der Wachhund oben kuerzt fuer
// '/info' und einige andere Pfade mit einem eigenen next() ab. Ein Stopp
// weiter unten wuerde genau die Seiten verfehlen, um die es geht.
//
// afterEach laeuft vor dem mounted der Zielseite. Seiten mit EIGENEM Video
// (MediaPlayer, VoD) stoppen also, BEVOR ihr Player startet - auf Tizen wichtig,
// weil clearChannel dort denselben avPlay anfasst.
router.afterEach((to) => {
  silenceTunerFor(to.name);
});

// Der TV tunt AUCH OHNE Seitenwechsel von selbst.
//
// Am Geraet belegt (LG, webOS 25): nach dem Verlassen einer OTT-App faellt der
// TV auf seinen internen Tuner zurueck und meldet das als hcap-Ereignis -
// 12:28:27 channel_status_changed, dann zweimal inband_data_service_ready, und
// der Gast hoerte auf der Cast-Seite den Ton eines fremden Senders. Der
// Router-Hook oben greift dort nicht: es gab keinen Seitenwechsel.
//
// hcap verteilt seine Ereignisse als DOM-Ereignisse auf document (siehe
// static/hcap.js und helpers/LgScreen). Auf anderen Plattformen feuert das nie,
// der Listener ist dort ein Nichts.
//
// SPERRE gegen Rueckkopplung: unser eigenes stop_current_channel aendert den
// Kanalzustand und loest damit dasselbe Ereignis aus. Ohne die Sperre
// antwortete die App auf ihren eigenen Stopp mit dem naechsten Stopp. Der
// Zeitstempel wird in silenceTunerFor() gesetzt, also bei JEDEM Stopp - auch
// bei dem aus afterEach.
if (typeof document !== 'undefined') {
  document.addEventListener('channel_status_changed', () => {
    const name = router.currentRoute && router.currentRoute.name;
    if (LIVE_VIDEO_ROUTES.indexOf(name) !== -1) return;
    // Date.now() statt eines Timers: der Vergleich kostet nichts und es bleibt
    // kein Timer stehen, wenn das Ereignis nie wieder kommt.
    const now = Date.now();
    if (now - lastTunerStop < TUNER_EVENT_QUIET_MS) return;
    lastTunerStop = now;
    console.log('[TV] Geraet hat von selbst getunt (channel_status_changed) auf Seite ' + (name || '?'));
    // Der Merker ist jetzt falsch - es laeuft ja wieder etwas.
    tunerSilenced = false;
    silenceTunerFor(name);
  });
}

export default router;
1;



// WEBPACK FOOTER //
// ./src/router/index.js